import React from 'react';
import HeroSection from './HeroSection';
import EmiSection from './EmiSection';
import EmiInfoSection from './EmiInfoSection';
import EmiCardsSection from './EmiCardsSection';
import usePageTitle from '../../hooks/UsePageTitle';

const EmiPage = () => {
    const someProductTypeValue = "Personal Loan";
    usePageTitle("Personal Loan EMI Calculator - Snapfunds");
  return (
    <>
      <HeroSection />
      <EmiSection productType={someProductTypeValue} />
     
      <EmiInfoSection />
      <EmiCardsSection />
    </>
  );
};

export default EmiPage;